import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBXtao-ISLibhw-h1Ox_Sfa-aBxZDJ-uT8",
  authDomain: "fifacollecttracking-ca55c.firebaseapp.com",
  projectId: "fifacollecttracking-ca55c",
  storageBucket: "fifacollecttracking-ca55c.firebasestorage.app",
  messagingSenderId: "792878188505",
  appId: "1:792878188505:web:95dba92bfe2f418bc1bbc8",
  measurementId: "G-W4JYPF2EKP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Analytics (only in browser environment)
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;
